import isEqual from 'lodash.isequal';
import { from, Observable, OperatorFunction, pipe, TruthyTypesOf } from 'rxjs';
import {
  distinctUntilChanged,
  filter,
  mergeAll,
  pluck,
  shareReplay,
  switchMap,
  switchMapTo,
} from 'rxjs/operators';

export const distinctUntilDeepChanged = <T>(): OperatorFunction<T, T> =>
  distinctUntilChanged(isEqual);

export const weakShareReplay = <T>(bufferSize = 1): OperatorFunction<T, T> =>
  shareReplay({ bufferSize, refCount: true });

export const repeatable = <T>(
  task: Observable<T>,
  notifier: Observable<unknown>
): Observable<T> =>
  from([task, notifier.pipe(switchMapTo(task))]).pipe(mergeAll());

export const repeatForEvery =
  <T, N>(notifier: Observable<N>): OperatorFunction<T, T> =>
  (task) =>
    repeatable(task, notifier);

export function explodeProp<
  T extends object,
  P1 extends Extract<keyof T, string>,
  P2 extends Extract<keyof T[P1], string>,
  R
>(prop1: P1, prop2?: P2): OperatorFunction<T, R> {
  const pluckArgs = [prop1, prop2].filter(
    (item): item is P1 | P2 => item !== undefined
  );
  return pipe(
    pluck(...pluckArgs),
    filter(Array.isArray),
    switchMap((res) => from(res))
  );
}

export function truthyObs<T>(obs: Observable<T>): Observable<TruthyTypesOf<T>> {
  return obs.pipe(filter(Boolean));
}
